import { PrimaryColors } from '@/common/theme/constants';
import { SxProps } from '@mui/material';

export enum DeviderVariants {
  dashed = 'dashed',
  solid = 'solid',
}

export const styledDevider = ({
  opacity,
  variants,
}: {
  opacity?: number;
  variants?: DeviderVariants;
}): SxProps => ({
  borderStyle: 'solid',
  margin: '1rem 0',
  borderWidth: '1px',
  width: '100%',
  borderColor: PrimaryColors.black,
  opacity: opacity ? opacity : 0.8,
  borderImage:
    variants === DeviderVariants.dashed
      ? 'repeating-linear-gradient(90deg, black 0, black 10px, transparent 10px, transparent 20px) 1'
      : 'none',
});
